import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { GmTokenService } from './gm-token.service';

@Injectable({
  providedIn: 'root',
})

export class GMAuthStateService {
  private userState = new BehaviorSubject<boolean>(this.token.isLoggedIn()!);
  userAuthState = this.userState.asObservable();
  constructor(public token: GmTokenService) {}
  setAuthState(value: boolean) {
    this.userState.next(value);
  }
}